import * as axios from './Axios'

const PREFIX = 'company'

export const _list = () => axios.get(`${PREFIX}/list`)
export const _save = company => axios.post(`${PREFIX}/save`, company)
export const _update = (id, company) => axios.put(`${PREFIX}/update/${id}`, company)
export const _show = id => axios.get(`${PREFIX}/show/${id}`)
export const _delete = id => axios.del(`${PREFIX}/delete/${id}`)

export const _withdraw = (id,data) => axios.post(`${PREFIX}/${id}/withdraw`, data)
export const _listPayments = company => axios.get(`${PREFIX}/${company}/list-payments`)

export const _upload_logo = (id, data) => axios.post(`admin/${PREFIX}/${id}/update/logo`, data)

// --- Company banner images (max 6 per company) ---
export const _list_banners = id => axios.get(`admin/${PREFIX}/${id}/banners`)
export const _upload_banner = (id, data) => axios.post(`admin/${PREFIX}/${id}/banners`, data)
export const _delete_banner = (id, bannerId) => axios.del(`admin/${PREFIX}/${id}/banners/${bannerId}`)
export const _update_settings = (id, data) => axios.post(`admin/${PREFIX}/${id}/update/settings`, data)
export const _update_charity = (id, data) => axios.post(`admin/${PREFIX}/${id}/update/charity`, data)
export const _charity_details = (id,data) => axios.post(`admin/${PREFIX}/${id}/charity-details/download`, data)



export const _list_venues = id => axios.get(`admin/${PREFIX}/${id}/venue/list`)

export const _list_bookings = (id,page) => axios.get(`admin/${PREFIX}/${id}/booking/list?page=${page}`)
export const _filter_bookings = (id, data, page) => axios.post(`admin/${PREFIX}/${id}/booking/filter?page=${page}`, data)
export const _filter_date_bookings = (id, data, page) => axios.post(`admin/${PREFIX}/${id}/booking/filter/date?page=${page}`, data)

export const _dashboard_record = id => axios.get(`admin/${PREFIX}/${id}/dashboard-record`)
export const _sms_payments = (id, data, page) => axios.post(`admin/${PREFIX}/${id}/sms-payments?page=${page}`, data)

export const _sub_users = (id, page) => axios.get(`admin/${PREFIX}/${id}/sub-users?page=${page}`)

export const _statistics = (id,page) => axios.get(`admin/${PREFIX}/${id}/statistics?page=${page}`)

export const _advance_statistics = (id,data) => axios.post(`admin/${PREFIX}/${id}/statistics/download`, data)

export const _filter_bookings_without_pagination = (id, data) => axios.post(`admin/${PREFIX}/${id}/booking/filterwithout-pagination`, data)


